import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { IGlobalConfiguration } from 'src/app/appModels/IGlobalConfiguration';
import { IKiosk } from 'src/app/appModels/IKiosk';
import { KioskService } from './kiosk.service';
import { TranslationService } from 'src/app/appServices/translation.service';
import { ToasterService } from 'src/app/appServices/toaster.service';

@Injectable({
  providedIn: 'root',
})
export class KioskResolver {
  kioskDetails = new BehaviorSubject<IKiosk | null>(null);
  kioskStatus = new BehaviorSubject<boolean>(true);

  globalConfiguration = new BehaviorSubject<IGlobalConfiguration | null>(null);

  constructor(
    private kioskService: KioskService,
    private toaster: ToasterService,
    private translationService: TranslationService
  ) {
    this.getGlobalConfig();
  }

  /**
   * get kiosk details by code
   * @param code
   * @returns
   */
  getKioskDetailsByCode(code: number): Observable<any> {
    return this.kioskService.getKioskDetailsByCode(code);
  }

  private getGlobalConfig() {
    this.kioskDetails.subscribe((res) => {
      if (res) {
        this.kioskService.getKioskConfiguration(res.clientType).subscribe(
          (res) => {
            this.globalConfiguration.next(res);
          },
          (err) => {
            const translatedMessage = this.translationService.translate(
              'KIOSK_NOT_CONFIGURED'
            );
            this.toaster.errorToastWithClose(translatedMessage);
          }
        );
      }
    });
  }

  /**
   * Get Tenant By Domain
   * @param domain
   * @returns
   */
  getTenantByDomain(domain: string) {
    return this.kioskService.getTenantByDomain(domain);
  }
}
